import * as React from 'react'

import { spacing, Text } from 'main/ui'
import { palette } from '../constants'
import RangeSlider, { IRangeProps } from './RangeSlider'
import { formatAgeFromMonths, IAgeLabels } from './util'

interface IProps {
  displayOptions: {
    displayBoundsAsAnyAge: boolean
    displaySliderRangeLabels: boolean
  }
  minValue: number
  maxValue: number
  step?: number
  value: IRangeProps
  onChange: (value: IRangeProps) => void
  labels?: IAgeLabels
}

export default function AgeRangeSlider(props: IProps) {
  const {
    displayOptions: { displayBoundsAsAnyAge, displaySliderRangeLabels },
    minValue,
    maxValue,
    step = 15,
    value,
    onChange,
    labels,
  } = props

  return (
    <div>
      <RangeLabel displayBoundsAsAnyAge={displayBoundsAsAnyAge} value={value} labels={labels} />
      <div
        style={{
          marginTop: `${spacing.majorScale(2)}px`,
          marginBottom: `${spacing.majorScale(2)}px`,
          marginLeft: `${spacing.minorScale(1)}px`,
          marginRight: `${spacing.minorScale(-4)}px`,
        }}
      >
        <RangeSlider
          range={{ min: minValue, max: maxValue }}
          step={step}
          value={value}
          onChange={onChange}
        />
        {displaySliderRangeLabels ? <RangeLabelBottom value={value} labels={labels} /> : null}
      </div>
    </div>
  )
}

const RangeLabel = (props: {
  displayBoundsAsAnyAge: boolean
  value: IRangeProps
  labels?: IAgeLabels
}) => {
  const {
    displayBoundsAsAnyAge,
    value: { min, max },
    labels,
  } = props
  const displayAsAbbreviations = false

  return (
    <Text style={{ color: palette.black }}>
      {formatAgeFromMonths(min, displayBoundsAsAnyAge, displayAsAbbreviations, labels)} -{' '}
      {formatAgeFromMonths(max, displayBoundsAsAnyAge, displayAsAbbreviations, labels)}
    </Text>
  )
}

const RangeLabelBottom = (props: { value: IRangeProps; labels?: IAgeLabels }) => {
  const {
    value: { min, max },
    labels,
  } = props
  const displayBoundsAsAnyAge = false
  const displayAsAbbreviations = true

  return (
    <div
      style={{
        color: palette.mediumGray,
        display: 'flex',
        fontSize: '11px',
        justifyContent: 'space-between',
        paddingTop: '2px',
      }}
    >
      <span style={{ marginLeft: '-10px' }}>
        {formatAgeFromMonths(min, displayBoundsAsAnyAge, displayAsAbbreviations, labels)}
      </span>
      <span style={{ marginRight: '12px' }}>
        {formatAgeFromMonths(max, displayBoundsAsAnyAge, displayAsAbbreviations, labels)}
      </span>
    </div>
  )
}
